<template lang="html">
  <div class="poi-content">
    <f7-list accordion-list>
      <f7-list-item
        v-for="p in content"
        :key="p.title"
        accordion-item
        :title="p.title">
        <f7-accordion-content>
          <f7-block>
            <p>{{ p.content }}</p>
          </f7-block>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
export default {
  name: 'PoiContent',
  props: {
    content: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>
